import { useState, useEffect } from 'react';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

// Fix for differing HTML between SSG/SSR and client
// Source: https://stackoverflow.com/questions/58293542/next-js-warning-expected-server-html-to-contain-a-matching-a-in-div-how-to#answer-68736194
const ClientOnly = _ref => {
  let {
    children
  } = _ref;
  const {
    0: hasMounted,
    1: setHasMounted
  } = useState(false);
  useEffect(() => {
    setHasMounted(true);
  }, []);

  if (!hasMounted) {
    return null;
  }

  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};

export default ClientOnly;